import { Box, Stack, styled, Typography } from '@mui/material';

export const Video = styled('video')`
  border-radius: 22px;
  cursor: pointer;
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;

  @media (max-width: 600px) {
    border-radius: 12px;
  }
`;

export const ControlsWrapper = styled(Stack)`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.blueGrey[800]};
  border-radius: 8px;
  margin: 1rem 0;
  padding: 0.5rem;
  height: 29px;
  flex-direction: row;
  align-items: center;
  svg {
    color: ${({ theme }) => theme.palette.common.white};
    cursor: pointer;
  }

  @media (max-width: 600px) {
    margin: 0.5rem 0;
    padding: 0.3rem;
  }
`;

export const ProgressBar = styled('input')<{ currentWidth?: string }>`
  --bar-bg: rgba(177, 177, 180, 0.32);
  --seek-before-width: ${({ currentWidth }) => currentWidth};
  --seek-before-color: rgba(177, 177, 180, 0.32);
  --knobby: ${({ theme }) => theme.palette.common.white};
  --selectedKnobby: ${({ theme }) => theme.palette.common.white};

  width: 100%;
  cursor: pointer;
  appearance: none;
  background: transparent;
  outline: none;
  border-radius: 16px;

  /* progress bar - safari */
  ::-webkit-slider-runnable-track {
    background: var(--bar-bg);
    position: relative;
    height: 5px;
    outline: none;
    border-radius: 16px;
  }

  /* progress bar - firefox */
  ::-moz-range-track {
    background: var(--bar-bg);
    position: relative;
    height: 5px;
    outline: none;
    border-radius: 16px;
  }

  ::-moz-focus-outer {
    border: 0;
    border-radius: 16px;
  }

  /* progress bar - chrome and safari */
  ::before {
    content: '';
    height: 5px;
    width: var(--seek-before-width);
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    cursor: pointer;
    border-radius: 16px;
  }

  /* progress bar - firefox */
  ::-moz-range-progress {
    background-color: var(--seek-before-color);
    height: 5px;
    border-radius: 16px;
  }

  /* knobby - chrome and safari */
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    border: none;
    background-color: ${({ theme }) => theme.palette.common.white};
    cursor: pointer;
    position: relative;
    margin: -4px 0 0 0;
    z-index: 3;
    box-sizing: border-box;
  }

  /* knobby while dragging - chrome and safari */
  :active::-webkit-slider-thumb {
    transform: scale(1.2);
    background: white;
  }

  /* knobby - firefox */
  ::-moz-range-thumb {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    border: transparent;
    background-color: var(--knobby);
    cursor: pointer;
    position: relative;
    z-index: 3;
    box-sizing: border-box;
  }

  /* knobby while dragging - firefox */
  :active::-moz-range-thumb {
    transform: scale(1.2);
    background: var(--selectedKnobby);
  }
`;

export const TimeText = styled(Typography)`
  font-size: 11px;
  color: rgba(235, 235, 245, 0.6);
  white-space: nowrap;
  flex-shrink: 0;
`;

export const SnapshotContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'isHovered' })<{
  isHovered: boolean;
}>`
  position: absolute;
  opacity: ${({ isHovered }) => (isHovered ? '1' : '0')};
  visibility: ${({ isHovered }) => (isHovered ? 'visible' : 'hidden')};
  display: block;
  z-index: 1000;
  width: 137px;
  height: 85px;
  bottom: 50px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: 2px solid #607d8b;
  }
`;

export const VideoIconBox = styled(Box)`
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.blueGrey[700]};
  border-radius: 50%;
  width: 64px;
  height: 64px;
  position: absolute;
  top: 50%;
  left: 50%;
  animation: fadeOut 2.5s ease-out;
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const ProgressBarContainer = styled(Stack)`
  position: relative;
  width: 100%;
  height: 20px;
  justify-content: center;
  margin: 0 8px;
`;

export const Marker = styled('div')`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;

  :hover {
    width: 10px;
    height: 10px;
  }
`;
